export const AnimatedOval = require("./Animated/Oval").default;
export const AnimatedDots = require("./Animated/Dots").default;
export const AnimatedPulse = require("./Animated/Pulse").default;

// export const Panel = require("./Panel").default;
